





































































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import {
  Card,
  Tag,
  Button,
  Icon,
  Image as VanImage,
  Swipe,
  SwipeItem,
  Row,
} from "vant";
import { Mixin } from "@/core/mixins/mixin";
import MySwiper from "@/components/MySwiper.vue";
import { zhugeTrack } from "@/utils";
@Component({
  components: {
    [Card.name]: Card,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [VanImage.name]: VanImage,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Row.name]: Row,
    MySwiper,
  },
})
export default class mallProList extends Mixins(Mixin) {
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  public mallRecommendList!: Array<good.CommodityDto>;
  @Prop({
    type: String,
    default: "",
  })
  public keyword!: "";
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  zhugeParams!: any; // 埋点参数
  @Prop({ default: "", type: String }) public type?: string; // 组件调用的页面
  @Watch("mallRecommendList", { deep: true })
  changeMallRecommendList(val: Array<good.CommodityDto>): void {
    this.mallRecommendList = val;
  }
  goGoodDetail(index: number, item: any): void {
    if (this.type == "search") {
      zhugeTrack("个人-点击搜索结果", {
        ...this.zhugeParams,
        位置序号: index,
      });
    }
    this.$router.push(`/mall/details?commodityId=${item.commodityId}`);
  }
  lineheight(str?: string): string {
    let string = str || "";
    if (this.keyword) {
      let reg = new RegExp(this.keyword, "g");
      string = (str as string).replace(reg, "<em>" + this.keyword + "</em>");
    }
    return string;
  }
}
